<div class="actions sso" *ngIf="ssoActif()">
	<button [ngClass]="{ 'btn-primary': !modeApplicationCohabitation, 'btn-secondary': modeApplicationCohabitation, 'flex': !modeApplicationCohabitation, 'mode-application-cohabitation': modeApplicationCohabitation }"
	        class="btn"
	        type="button"
	        (click)="loginAvecMicrosoft()"
	        [disabled]="loading">
		<img class="sso-image"/><span>Utiliser mon compte entreprise</span>
		<span class="identifiant" *ngIf="nomUtilisateurMicrosoftConnecte">({{ nomUtilisateurMicrosoftConnecte }})</span><span *ngIf="loading" class="app-spinner-white"></span>
	</button>
</div>
@if (!estSsoOnly && ssoActif()) {
	<div class="separator" (click)="toggleAutreOptionsPossibles()">
		Autre option possible<i class="pi pi-chevron-down"></i>
	</div>
}
